import { useState, useEffect } from 'react';
import { WifiOff, X } from 'lucide-react';

export function OfflineBadge() {
  const [offline, setOffline] = useState(!navigator.onLine);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const goOffline = () => { setOffline(true); setDismissed(false); };
    const goOnline = () => setOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!offline || dismissed) return null;

  return (
    <div
      className="lg:hidden fixed top-16 left-0 right-0 z-50 flex items-center justify-between px-4 py-2 bg-amber-500/95 backdrop-blur-sm text-white text-xs font-medium"
      data-testid="offline-badge"
    >
      <div className="flex items-center gap-2">
        <WifiOff className="w-3.5 h-3.5" />
        <span>You&apos;re offline — actions will sync when reconnected</span>
      </div>
      <button onClick={() => setDismissed(true)} className="p-1 rounded hover:bg-white/20" data-testid="dismiss-offline-badge">
        <X className="w-3 h-3" />
      </button>
    </div>
  );
}

export default OfflineBadge;
